export const eLearningMethods = {
  methods:{
    finished(movies){
      let finished = [];
      movies.forEach(movie => {
        if(movie.done)
          finished.push(movie)
        })
      return finished.length
    },
  }
}
export const eLearningLessons = {
  methods:{
    calculatedWidth(finishedLessons, lessonsLength) {
      return (finishedLessons / lessonsLength) * 100;
    },
    learningTime(movies){
      let hours = 0;
      let minutes = 0;
      movies.forEach(movie => {
        if(!movie.done){
          hours += Number(movie.time.slice(0,2));
          minutes += Number(movie.time.slice(3,5));
        }
      });
      minutes += hours * 60;
      hours = (minutes / 60);
      let rhours = Math.floor(hours);
      minutes = (hours - rhours) * 60;
      let rminutes = Math.round(minutes);
      return (rhours !== 0 ? rhours + " h " : '') + (rminutes !== 0 ? rminutes + " min" : '')
    },
    movieTime(time){
      let hours = 0;
      let minutes = 0;
      hours = Number(time.slice(0,2));
      minutes = Number(time.slice(3,5));
      minutes += hours * 60;
      hours = minutes / 60;
      let rhours = Math.floor(hours);
      minutes = (hours - rhours) * 60;
      let rminutes = Math.round(minutes);
      return (rhours !== 0 ? rhours + ' h ' : '') + (rminutes !== 0 ? rminutes + ' min' : '' );
    },
    collapse(id){
      if(id === 0) return;
      
      let collapse = document.querySelectorAll(".e-learning-box");
      collapse = [...collapse];
      let collapseBoxes = document.querySelectorAll('.e-learning-collapse');
      collapseBoxes = [...collapseBoxes];
      
      if (collapseBoxes[id - 1].classList.contains("active")) {
        collapseBoxes.forEach(box => box.classList.remove("active"));
        collapse[id-1].classList.remove('active')
      } else {
        collapseBoxes.forEach(box => box.classList.remove("active"));
        collapse.forEach(box => box.classList.remove("active"));
        collapseBoxes[id - 1].classList.add("active");
        collapse[id-1].classList.add('active')
      }
    },
  }
}